"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const styles_1 = require("@mui/material/styles");
const Drawer_1 = __importDefault(require("@mui/material/Drawer"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const common_buoy_icons_1 = require("@buoyhealth/common.buoy-icons");
const PopupDrawer = (0, styled_components_1.default)(Drawer_1.default) `
  .MuiDrawer-paper {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    height: 90%;
  }
`;
const PopupPrompt = (0, styled_components_1.default)(Drawer_1.default) `
  .MuiDrawer-paper {
    box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14),
      0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.2);
  }
`;
const DrawerContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    padding: 32px;
  }
`;
const PromptContainer = styled_components_1.default.div `
  padding: 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;
const DrawerCloseButtonContainer = styled_components_1.default.div `
  position: absolute;
  top: 8px;
  right: 8px;
`;
const PromptCloseButtonContainer = styled_components_1.default.div `
  margin: 3px;
`;
const MobilePrompt = ({ children, handleClose, DrawerHeader, popupVariant = "prompt", isPopupVisible, ...rest }) => {
    const theme = (0, styles_1.useTheme)();
    if (popupVariant === "prompt") {
        return ((0, jsx_runtime_1.jsx)(PopupPrompt, { anchor: "bottom", open: isPopupVisible, variant: "persistent", ...rest, children: (0, jsx_runtime_1.jsxs)(PromptContainer, { children: [children, (0, jsx_runtime_1.jsx)(PromptCloseButtonContainer, { children: (0, jsx_runtime_1.jsx)(IconButton_1.default, { "data-testid": "prompt-close-button", onClick: handleClose, children: (0, jsx_runtime_1.jsx)(common_buoy_icons_1.CloseIconThin, { color: theme.palette.text.primary, size: 24 }) }) })] }) }));
    }
    return ((0, jsx_runtime_1.jsxs)(PopupDrawer, { anchor: "bottom", open: isPopupVisible, ...rest, children: [DrawerHeader ? ((0, jsx_runtime_1.jsx)(DrawerHeader, {})) : ((0, jsx_runtime_1.jsx)(DrawerCloseButtonContainer, { children: (0, jsx_runtime_1.jsx)(IconButton_1.default, { "data-testid": "drawer-close-button", onClick: handleClose, children: (0, jsx_runtime_1.jsx)(common_buoy_icons_1.CloseIconThin, { color: theme.palette.primary.main, size: 32 }) }) })), (0, jsx_runtime_1.jsx)(DrawerContainer, { children: children })] }));
};
exports.default = MobilePrompt;
//# sourceMappingURL=index.js.map